import React from "react";
import { Link } from "react-router-dom";
import { mediaUrl } from "../lib/api";
import BlockchainBadge from "./BlockchainBadge";

export default function RelatedPosts({ items = [] }) {
  if (!items || items.length === 0) return null;
  return (
    <section data-testid="related-posts" style={{ marginTop: 40 }}>
      <h2 className="xs-section-title">related</h2>
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fill, minmax(220px, 1fr))",
          gap: 14,
        }}
      >
        {items.map((p) => (
          <Link
            key={p.id}
            to={`/articles/${p.slug}`}
            className="xs-card"
            style={{ textDecoration: "none" }}
            data-testid={`related-${p.slug}`}
          >
            {p.cover_image_url && (
              <img
                src={mediaUrl(p.cover_image_url)}
                alt=""
                className="xs-card-cover"
                loading="lazy"
              />
            )}
            <div className="xs-card-body">
              <div className="xs-card-title" style={{ fontSize: "0.95em" }}>{p.title}</div>
              <div className="xs-card-meta" style={{ fontSize: "0.72em" }}>
                {p.tags?.slice(0, 2).map((t) => <span key={t} className="xs-tag">#{t}</span>)}
                <BlockchainBadge hash={p.blockchain_hash} status={p.opentimestamps_status} compact />
              </div>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}
